export default {
    title: '<h1>100%<span>&nbsp;Sin</span><p>&nbsp;Riesgos</p></h1>',
    free: {
        banner_text: 'https://web-data.zmlearn.com/image/nhjPDchd7YNGgL8UgoK4PL/slogan%402x.png',
        button: 'https://web-data.zmlearn.com/image/bP921zvp5DLgCvEoaRGMCV/btn_home_banner%402x.png',
    },
    lesson: {
        title: 'Curso NIÑOS FELICES',
        list: [
            [{
                id: 1,
                img: 'https://web-data.zmlearn.com/image/9HcWfESDMsmknyFLB3xeoU/1%402x.png',
            },
            {
                id: 2,
                img: 'https://web-data.zmlearn.com/image/6cbbmHxCRg3H9DKDuc6L4/2%402x.png'
            },
            {
                id: 3,
                img: 'https://web-data.zmlearn.com/image/wa8jTHTNJ766wbjX1K999E/3%402x.png'
            },
            {
                id: 4,
                img: 'https://web-data.zmlearn.com/image/ihuFrk5C48PsK8gEtPJqGX/4_2x.png'
            },],
            [
                {
                    id: 1,
                    img: 'https://web-data.zmlearn.com/image/t6ADE5XX92dEPWDVk7egRF/1%402x%20(1).png'
                },
                {
                    id: 2,
                    img: 'https://web-data.zmlearn.com/image/sHo8N7rAsyEPNPAYGmVKns/2%402x%20(1).png'
                },
                {
                    id: 3,
                    img: 'https://web-data.zmlearn.com/image/2AmM49X5kKGcAUpjo8SG8C/3%402x%20(1).png'
                },
                {
                    id: 4,
                    img: 'https://web-data.zmlearn.com/image/ed4GFAtotDAktccf4KGsLF/4%402x.png'
                },
            ]
        ],
        buttons: [
            'https://web-data.zmlearn.com/image/tY33St4yf3Nm1FEdb57W55/%E8%8B%B1%E8%AF%AD%402x.png',
            'https://web-data.zmlearn.com/image/9DET8Xtz15q2tZTAKAote1/%E6%95%B0%E5%AD%A6%402x.png'
        ]
    },
    curriculum: {
        title: 'Un sistema con planes de estudio integrales',
        list: [
            {
                id: 1,
                img: 'https://web-data.zmlearn.com/image/upt2GF1VYC27tLDz88uvMZ/%E8%8B%B1%E8%AF%AD%402x%20(1).png',
                pImg: 'https://web-data.zmlearn.com/image/ea9EDHszSEjd94HcktST2H/%E8%8B%B1%E8%AF%AD-%E5%9B%BE%401x.png',
            },
            {
                id: 2,
                img: 'https://web-data.zmlearn.com/image/cbsBiTvwBsAi3Mc7ncekZn/%E6%95%B0%E5%AD%A6%402x%E7%9A%84%E5%89%AF%E6%9C%AC.png',
                pImg: 'https://web-data.zmlearn.com/image/9xUMi573bmxSrSGHQRfjUa/%E6%95%B0%E5%AD%A6-%E5%9B%BE%402x.png',
            },
        ]
    },
    growth: {
        title: 'Sistema de crecimiento',
        list: [
            {
                id: 1,
                img: 'https://web-data.zmlearn.com/image/7FEaAeZdLAAHuGrPH4H1DM/%E8%AF%BE%E7%A8%8B-english%402x.png',
            },
            {
                id: 2,
                img: 'https://web-data.zmlearn.com/image/rkpMNy1VqRwGM8Crh4x81x/%E8%AF%BE%E7%A8%8B-Math%402x.png'
            },

        ]
    },
    outcome: {
        title: 'Resultado del aprendizaje',
        en: `<h4><span>5 características </span> del<p> inglés</p></h4>`,
        math: `<h4><span>6 características </span>del<p style={{ color: '#32C095' }}> las matemáticas</p></h4>`,
        list: [[
            {
                id: 1,
                title: 'Vocabulario',
                span: '600+ ',
                context: 'palabras de alta frecuencia',
                img: 'https://web-data.zmlearn.com/image/9srJHHEkVZysd8DGzFSKyY/EN-1-icon%402x.png',
            },
            {
                id: 2,
                title: 'Expresión oral',
                span: '85+ ',
                context: 'Estructura de oraciones',
                img: 'https://web-data.zmlearn.com/image/g5izC2PySdAZvU2pv6WZb6/EN-2-icon%402x.png',
            },
            {
                id: 3,
                title: 'Lectura',
                span: '15+ ',
                context: 'Estrategia de lectura',
                img: 'https://web-data.zmlearn.com/image/mWMrMpBirLXz85vMecSsAR/EN-3-icon%402x.png',
            },
            {
                id: 4,
                title: 'Gramática',
                span: '75+ ',
                context: 'Reglas gramaticales',
                img: 'https://web-data.zmlearn.com/image/qLUVyti4JZZGy95wz1pzd8/EN-4-icon%402x.png',
            },
            {
                id: 5,
                title: 'Redacción',
                span: '30+ ',
                context: 'Habilidades de escritura',
                img: 'https://web-data.zmlearn.com/image/xXABu4tFbFEarF3qvNBvo/EN-5-icon%402x.png',
            },
        ],
        [
            {
                id: 1,
                title: 'Número',
                span: '',
                context: 'Incluye valor posicional, cálculo y fracciones.',
                img: 'https://web-data.zmlearn.com/image/sY16jqTBYxGBLVyLUjLWnG/Math-1-icon%402x.png',
            },
            {
                id: 2,
                title: 'Reglas de número',
                span: '',
                context: 'Comprensión de sumas, restas, multiplicaciones y divisiones.',
                img: 'https://web-data.zmlearn.com/image/iu1eX55fXiWT1KbyEkMedo/Math-2-icon%402x.png',
            },
            {
                id: 3,
                title: 'Medición',
                span: '',
                context: 'Elegir y usar unidades estándar apropiadas para estimar y medir.',
                img: 'https://web-data.zmlearn.com/image/9K7wtLaBueedEGTJ8iSxdj/Math-3-icon%402x.png',
            },
            {
                id: 4,
                title: 'Geometría',
                span: '',
                context: 'Leer y escribir nombres de formas, identificar y describir las propiedades de las formas.',
                img: 'https://web-data.zmlearn.com/image/aHzvusTWtxGBS2ouzDciLe/Math-4-icon%402x.png',
            },
            {
                id: 5,
                title: 'Estadísticas',
                span: '',
                context: 'Ser capaz de describir una gran cantidad de datos de forma gráfica o numérica.',
                img: 'https://web-data.zmlearn.com/image/oLA63jVaf3Ufo3c3nXxWRY/Math-5-icon%402x.png',
            },
            {
                id: 6,
                title: 'Fracciones',
                span: '',
                context: 'Comprender el concepto de fracciones, ser capaz de simplificar una fracción y comparar fracciones.',
                img: 'https://web-data.zmlearn.com/image/aUtJb96nyXSS5ZWAbtsVhE/Math-6-icon%402x.png',
            },
        ]]
    },
    comments: {
        title: 'Voz real de los padres',
        list: [
            {
                id: 1,
                name: `Mamá de Amelia`,
                content: `A mi hijo le gusta mucho este modo de aprendizaje tan interesante. Cada vez que aprende, muestra su gran interés por la clase y presta mucha atención a cada palabra que diga el tutor. Ha desarrollado sus hábitos del aprendizaje independiente gracias a su tutor.  Solía encontrar difícil y aburrido aprender inglés. Este servicio me sorprendió.`,
                icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
                img: 'https://web-data.zmlearn.com/image/gPExCEpox63YkuKnT5aghf/Amymom%402x.png',
            },
            {
                id: 2,
                name: `Mamá de Cindy`,
                content: `Una cosa que tengo que mencionar es que gracias al curso de Airclass 1-on-1, mi hijo superó sus problemas con la lectura debido a la falta de base de vocabulario inglés. Ahora su pronunciación es mucho mejor que antes. Admás, ha obtenido confianza y está dispuesto a hablar en la clase. `,
                icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
                img: 'https://web-data.zmlearn.com/image/s35Anxhhhw2AS4MBXefeM1/cindymom%402x.png',
            },
            {
                id: 3,
                name: `Papá de Jaime`,
                content: `El programa de Happy Maths es mucho más divertido de lo que pensaba. Le gusta compartir lo que aprendió durante su clase de la escuela con su mamá y yo, y puedo sentir que ahora tiene más confianza, ¡Estamos muy orgullosos de el! `,
                icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
                img: 'https://web-data.zmlearn.com/image/pWCmcvCkGTvwwoKMJgVEzx/Jamesfather%402x.png',
            },

        ]
    }

}